module.exports = __webpack_public_path__ + "static/media/bannerMobile@2x.258cd96f.png";